import { Box, Button } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useLanguage } from '../../LanguageContext';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import PageContent from '../PageContent/PageContent';
import Sidebar from '../Sidebar/Sidebar';

const GenericError: any = () => {

    const { paymentSolutionName } = useParams<{ paymentSolutionName: string }>();
    const { culture } = useParams<{ culture: string }>();
    const navigate = useNavigate();

    //Handle translation
    const { changeLanguage } = useLanguage();
    const { t } = useTranslation();
    useEffect(() => {
        if (culture) {
            changeLanguage(culture);
        }
    }, [culture]);

    let allowRetry: boolean = !!paymentSolutionName;

    document.title = t('Document_title_error');
    const title: string = t('GenericError_title');
    const message: string = `${t('GenericError_message')} ${allowRetry ? t('GenericError_retryText') : "" }`;
    const buttonText: string = t('GenericError_buttonText');

    const handleClick = () => {
        if (paymentSolutionName)
            navigate(`/${paymentSolutionName}/${culture}`);
    }

    const retryElement = allowRetry ?
        <>
            <hr />
            <Box className="center-container">
                <Box className="center-item">
                    <Button variant="contained" id="retryButton" data-test-id="retry-application-button" className="fullsteam-button" onClick={handleClick}>{buttonText}</Button>
                </Box>
            </Box>
        </> : <></>

    return (

        <Box id="error">
            <Box className="banner" />
            <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                <Grid size={{ xs: 4, sm: 8, md: 4 }}>
                    <Sidebar showPanel={false} />
                </Grid>
                <Grid size={{ xs: 4, sm: 8, md: 8 }}>
                    <Header>{title}</Header>
                    <PageContent title={message}>
                        {retryElement}
                    </PageContent>
                    <Footer culture={culture} />
                </Grid>
            </Grid>
        </Box>
    );
}

export default GenericError;